import React from 'react';
import { CredentialsType } from '../connector-configure-types';
import { ICredentialsFormSwitchProps } from '../connectors-types';
import AWSAssumeRoleForm from './AWSAssumeRoleForm';
import ClientIdSecretKeyForm from './ClientIdSecretKeyForm';
import TokenAndUserForm from './TokenAndUserForm';
import TokenCredentialsForm from './TokenCredentialsForm';
import UserPasswordCredentialsForm from './UserPasswordCredentialsForm';

const CredentialsFormSwitch: React.FC<
  React.PropsWithChildren<ICredentialsFormSwitchProps>
> = ({ credentialsFormProps, credentialsType }) => {
  switch (credentialsType) {
    case CredentialsType.Token: {
      return <TokenCredentialsForm {...credentialsFormProps} />;
    }
    case CredentialsType.UserPassword: {
      return <UserPasswordCredentialsForm {...credentialsFormProps} />;
    }
    case CredentialsType.TokenAndUser: {
      return <TokenAndUserForm {...credentialsFormProps} />;
    }

    case CredentialsType.ApiKey: {
      return <TokenCredentialsForm {...credentialsFormProps} />;
    }
    case CredentialsType.ClientIdSecretKey: {
      return <ClientIdSecretKeyForm {...credentialsFormProps} />;
    }
    case CredentialsType.UserPasswordAndTenant:
      return <UserPasswordCredentialsForm {...credentialsFormProps} />;
    case CredentialsType.AWSAssumeRoleCloudFormation:
    case CredentialsType.AWSOrganizationConnection:
    case CredentialsType.AWSAssumeRole:
    case CredentialsType.AWSAssumeRoleCloudFormationOnprem:
    case CredentialsType.AWSOrganizationConnectionOnprem:
    case CredentialsType.AWSAssumeRoleOnprem: {
      return <AWSAssumeRoleForm {...credentialsFormProps} />;
    }
    default: {
      return null;
    }
  }
};

export default CredentialsFormSwitch;
